import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { OrderOnboardingViewModel, ProductDataModel } from 'models/generated/Models.OrderOnboardingView';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';

@Component({
	selector: 'blocklist-order-onboarding',
	templateUrl: './blocklist-order-onboarding.component.html',
	styleUrls: ['./blocklist-order-onboarding.component.scss'],
	imports: [NgClass, CurrencyPipe, TranslatePipe, CustomDatePipe]
})
export class BlockListOrderOnboardingComponent {

	@Input() orderOnboardingView!: OrderOnboardingViewModel;

	getTotalValue() {
		return this.orderOnboardingView.orders.map((orderData) => orderData.products).reduce((accumulatedProducts, products) =>
				accumulatedProducts.concat(products), []).map(product => product.productValue).reduce((sum, productValue) => sum + productValue);
	}

	getOnboardingStatusStyle(product: ProductDataModel): string{
		if (product.invoiced) return 'invoiced';
		if (this.orderOnboardingView.activeQualificationCall) return 'incomplete-qualification-call';
		if (product.containOpenOnboardingTaskflows) return 'onboarded';
		return 'not-onboarded';
	}
}
